import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import {PopupType} from "../popups/popupType";
import {EstimateSubtotalRowPopupParams} from "../../components/estimate-subtotal-row-popup/estimate-subtotal-row-popup";
import {PopupMode} from "../popups/popup";
import {Application} from "../application";
import * as ko from "knockout";

export class CreateEstimateSubtotalRowCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.CreateEstimateSubtotalRow;
    canExecute = ko.computed(() => {

        let estimate = this.app.state.estimate();

        if (!estimate)
            return false;

        return this.app.state.canCreateEstimateSubtotalRow();
    });

    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });

    execute(data: { insertAbove: boolean, fromCostbook: boolean }): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();
        
        if(!data)
            return this.app.popupsManager.show(PopupType.estimateSubtotalRow, false);

        return this.app.popupsManager.show(PopupType.estimateSubtotalRow, false,<EstimateSubtotalRowPopupParams>{
            insertAbove: data.insertAbove,
            popupMode: data.fromCostbook ? PopupMode.NewFromCostRow : PopupMode.New
        });
    }

    name = "Create New Subtotal Row";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/createEstimateSubtotalRowCommand.ts